import { mapState } from 'vuex';
import {
  AddressingType,
  BuildingDTO,
  EntrancePlantDetailDTO,
} from '@/../client-generator/generated-clients/plants';
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'BuildingItem',
  props: {
    building: {
      type: BuildingDTO,
      required: true,
    },
  },
  computed: {
    ...mapState(['currentEntrancePlant']),
  },
  emits: ['building-selected'],
})
export default class BuildingItem extends Vue {
  building!: BuildingDTO;
  currentEntrancePlant!: EntrancePlantDetailDTO;

  get risersFloorApartmentCount() {
    const parts: string[] = [];
    if (this.currentEntrancePlant.hasRiserInterface) {
      if (this.building.backboneInterface != null) {
        parts.push(this.$t('AppResourceEP.Backbone'));
      }
      
      const risersLength = this.building.risers?.length ?? 0;
      if (risersLength > 0) parts.push(`${risersLength} ${this.$t('AppResourceEP.Risers')}`);
      return parts.length > 0 ? parts.join(', ') : this.$t('AppResource.Empty');
    } else {
      if (this.currentEntrancePlant.addressingType === AddressingType.BuildingRiserFloorApartment) {
        const risersLength = this.building.risers?.length ?? 0;
        if (risersLength > 0) parts.push(`${risersLength} ${this.$t('AppResourceEP.Risers')}`);
        const floorsLength = this.building.floors?.length ?? 0;
        if (floorsLength > 0) parts.push(`${floorsLength} ${this.$t('AppResourceEP.Floors')}`);
      }

      const apartmentsLength = this.building.apartments?.length ?? 0;
      if (apartmentsLength > 0) parts.push(`${apartmentsLength} ${this.$t('AppResourceEP.Apartments')}`);

      return parts.length > 0 ? parts.join(' ') : this.$t('AppResource.Empty');
    }
  }
}
